"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var sizes = {
  sm: {
    height: _tokens.spacing.vertical.xxxxs
  },
  md: {
    height: _tokens.spacing.vertical.xxs
  }
};
var _default = sizes;
exports.default = _default;